import Formatters from "@/utils/Formatters";

export default {
  state: {
    currentUser: {},
    unityAndProfile: {},
    patientData: {},
    donorPCRData: {},
    pcrDeathData: {},
    clinicalReports: {},
    antecedentes: {},
    captationData: {},
    captationDraft: {
      tab: 0,
      captationId: null,
    },
    donorId: "",
    orgonsCapturedData: [],
    orgonsData: [],
    clinicalHistories: {},
    MEClinicalHistories: {},
    macroscopicData: [],
    kidneysData: {},
    bloodGroupsPatientData: {},
    serologyPatientData: {},
  },

  getters: {
    getCurrentUser(state) {
      return state.currentUser;
    },

    getUnityAndProfile(state) {
      return state.unityAndProfile;
    },

    getPatientData(state) {
      return state.patientData;
    },

    getPCRDonorData(state) {
      return state.donorPCRData;
    },

    getPCRDeathData(state) {
      return state.pcrDeathData;
    },

    getClinicalReports(state) {
      return state.clinicalReports;
    },

    getDonorId(state) {
      return state.donorId;
    },

    getCaptationData(state) {
      return state.captationData;
    },

    getOrgonsCapturesData(state) {
      return state.orgonsCapturedData;
    },

    /**
     * Returns the list of all organs.
     * @return {Array} - List of all organs.
     */
    getOrgonsData(state) {
      return state.orgonsData;
    },

    getClinicalHistories(state) {
      return state.clinicalHistories;
    },

    getMacroscopicData(state) {
      return state.macroscopicData;
    },

    getMEClinicalHistories(state) {
      return state.MEClinicalHistories;
    },

    getKidneysData(state) {
      return state.kidneysData;
    },

    getBloodGroupsPatientData(state) {
      return state.bloodGroupsPatientData;
    },

    getSorologyPatientData(state) {
      return state.serologyPatientData;
    },
  },

  mutations: {
    setCurrentUser(state, data) {
      state.currentUser = data;
    },

    setUnityAndProfile(state, data) {
      state.unityAndProfile = data;
    },

    setPatientData(state, data) {   
      state.patientData = {
        captation_id: data?.captation_id ?? null,
        id: data?.id ?? null,
        kind_of_donor_id: data?.kind_of_donor_id ?? null,
        kind_of_donor: data?.kind_of_donor
          ? typeof data.kind_of_donor === "object"
            ? data.kind_of_donor.name
            : data.kind_of_donor
          : null,
        medical_records: data?.medical_records ?? null,
        name: data?.name ?? null,
        cpf: data?.cpf ?? null,
        rg: data?.rg ?? null,
        gender_id: data?.gender_id ?? null,
        sex_id: Number(data?.sex_id) ?? null,
        breed_id: Number(data?.breed_id) ?? null,
        idade_provavel: data?.idade_provavel ?? null,
        birth_date: data?.birth_date
          ? Formatters.dataAtualFormatada(data.birth_date)
          : null,
        sus_card: data?.sus_card ?? null,
        initial_diagnosis_id: data?.initial_diagnosis_id
          ? parseInt(data.initial_diagnosis_id)
          : null,
        initial_diagnosis: data?.initial_diagnosis ?? null,
        country: data?.country ?? null,
        mother_name: data?.mother_name ?? null,
        telephone: data?.telephone ?? null,
        hospital_id: Number(data?.unity_id) ?? null,
        cnes: data.cnes ?? null,
        inpatient_sector_id: Number(data?.inpatient_sector_id) ?? null,
        phone_sector_extension: data?.phone_sector_extension ?? null,
        country_id: Number(data?.country_id) ?? null,
        opo_reference_id: Number(data?.opo_reference_id) ?? null,
        kinship_id: data?.kinship_id ?? null,
        pcr_death_data: Number(data?.pcr_death_data) ?? null,
        action: data?.action ?? null,
        rgct: data?.rgct ?? null,
        responsible: data?.responsible ?? null,
        zip_code: data?.zip_code ?? null,
        state: data?.state ?? null,
        municipality: data?.municipality ?? null,
        district: data?.district ?? null,
        number: data?.number ?? null,
        address: data?.address ?? null,
        complement: data?.complement ?? null,
        family_authorization: data?.family_authorization ?? null,
        donor_status_id: Number(data?.donor_status_id) ?? null,
        donor_status_slug: data?.donor_status ? data.donor_status.slug : null,
        not_suitable_for_donor_flag:
          data?.not_suitable_for_donor_flag !== undefined
            ? Number(data.not_suitable_for_donor_flag)
            : null,
        initial_assessment: data?.initial_assessment ?? null,
        family_interviews: data?.family_interviews ?? null,
        brain_death_protocols: data?.brain_death_protocols ? data.brain_death_protocols[0] : null,
        encerramento_pme: data?.encerramento_pme ? data.encerramento_pme : null
      };
    },

    setPCRDonorData(state, data = {}) {
      const isNull = !data || Object.keys(data).length === 0;

      state.donorPCRData = {
        donor_id: !isNull ? data.id : "",
        donor_name: !isNull ? data.name : "",
        macroscopic_pcr_donor: !isNull ? data.macroscopic_pcr_donor : [],
      };
    },

    setMacroscopicData(state, data = {}) {
      const isNull = !data || Object.keys(data).length === 0;

      state.macroscopicData = !isNull ? data : [];
    },

    setPCRDeathData(state, data = {}) {
      const isNull = !data || Object.keys(data).length === 0;

      state.pcrDeathData = !isNull ? data : {};
      state.pcrDeathData.patientId = !isNull ? data.id : {};
      state.pcrDeathData.pcr_date = !isNull
        ? Formatters.dataAtualFormatada(data.pcr_date)
        : "";
      state.pcrDeathData.ending_pme_date = data?.ending_pme_date
        ? Formatters.dataAtualFormatada(data.ending_pme_date)
        : null;
    },

    setClinicalReportsData(state, data = {}) {
      const isNull = !data || Object.keys(data).length === 0;

      (state.clinicalReports = data),
        (state.clinicalReports.admission_date =
          data.admission_date != null
            ? Formatters.dataAtualFormatada(data.admission_date)
            : ""),
        (state.clinicalReports.diagnostic_id = !isNull
          ? parseInt(data.diagnostic_id)
          : ""),
        (state.clinicalReports.comorbidity_id = !isNull
          ? parseInt(data.comorbidity_id)
          : ""),
        (state.clinicalReports.pcr_reports_items = !isNull
          ? data.pcr_reports
          : "");
      state.clinicalReports.pcr_reports = !isNull
        ? data.pcr_reports.length
          ? "SIM"
          : "NÃO"
        : ""; 
    },

    setAntecedentesData(state, data = {}) {
      const isNull = !data || Object.keys(data).length === 0;

      state.antecedentes = {
        donor_id: !isNull ? data.donor_id : "",
        clinical_reports_id: !isNull ? data.id : "",
        blood_products: !isNull ? data.clinical_reports_id : "",
      };
    },

    setDonorId(state, data) {
      state.donorId = data;
    },

    setCaptationData(state, data) {
      state.captationData = data;
    },

    setCaptationDraft(state, data) {
      state.captationDraft = data;
    },

    clearCaptationDraft(state) {
      state.captationDraft = {
        tab: 0,
        captationId: null,
      };
    },

    setOrgonsCapturedsData(state, data) {
      //TRAZ SÓ OS CAPTADOS
      state.orgonsCapturedData = data.filter(
        (x) => x.orgon_captured_status_id == "1",
      );
    },

    setOrgonsData(state, data) {
      state.orgonsData = data;
    },

    setClinicalHistories(state, data) {
      state.clinicalHistories = data;
    },

    setMEClinicalHistories(state, data) {
      state.MEClinicalHistories = data;
    },

    setKidneysData(state, data) {
      state.kidneysData = data;
    },

    setBloodGroupsPatientData(state, data) {
      state.bloodGroupsPatientData = data;
    },

    setSerologyPatientData(state, data) {
      state.serologyPatientData = data;
    },
  },

  actions: {
    changeCurrentUser(context, infos) {
      context.commit("setCurrentUser", infos);
    },
    changeUnityAndProfile(context, infos) {
      context.commit("setUnityAndProfile", infos);
    },
    changePatientData(context, infos) {
      context.commit("setPatientData", infos);
    },

    changeForPCRPatientData(context, infos) {
      context.commit("setPCRDonorData", infos);
    },

    changeMacroscopicData(context, infos) {
      context.commit("setMacroscopicData", infos);
    },

    changePCRDeathData(context, infos) {
      context.commit("setPCRDeathData", infos);
    },

    changeClinicalReportsData(context, infos) {
      context.commit("setClinicalReportsData", infos),
        context.commit("setAntecedentesData", infos);
    },

    changeMEClinicalHistories(context, infos) {
      context.commit("setMEClinicalHistories", infos);
    },

    changeDonorId(context, infos) {
      context.commit("setDonorId", infos);
    },

    changeCaptationData(context, infos) {
      context.commit("setCaptationData", infos);
    },
    changeClinicalHistories(context, infos) {
      context.commit("setClinicalHistories", infos);
    },

    changeOrgonsCaptureds(context, infos) {
      context.commit("setOrgonsCapturedsData", infos);
    },

    changeOrgonData(context, infos) {
      context.commit("setOrgonsData", infos);
    },

    changeKidneyData(context, infos) {
      context.commit("setKidneysData", infos);
    },

    changeBloodGroupsPatientData(context, infos) {
      context.commit("setBloodGroupsPatientData", infos);
    },

    changeSerologyPatientData(context, infos) {
      context.commit("setSerologyPatientData", infos);
    },
  },
};
